import React from "react";
import "../../css/my style.css";
import "../../css/my style3.css";
import "../../components/my script";
import Sidenav from "../../components/Sidenav/PHPSidenav";
import Navbar from "../../components/navbar";
import Footertutorials from "../../components/Footer-tutorials";
import SyntaxHighlighterComponent from "../../components/SyntaxHighlighterComponent";
import ButtonNext from "../../components/Buttonnext";
import Tryitout from "../../components/Tryitoutbutton";
import PHPMetatag from "../../components/PHP_Metatag";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import ButtonPrevious from "../../components/Buttonprevious";
import ScrollToTopLink from "../../components/ScrollToTop";



export default function PHPPrint() {
    var newCode = {
    padding: '20px',
    textAlign: 'left',
    background: 'white',
    color: 'black'
    }
    var secondCode = {
        color: 'black'
    }
    var thirdCode = {
        padding: '20px'
    }
    const code = `
    print "Hello, World!";

    `;
    const code2 = `
    <?php
     print "Hello, World!";
    ?>

    `;
    const code3 = `
    Hello, World!
    
    `;

    const code4 = `
    <?php
    $name = "John";
    print "Hello, $name!";
    ?>

    `;

    const code5 = `
    Hello, John!

    `;

    const code6 = `
    <?php
    $greeting = "Hello,";
    $name = "Jane";
    print $greeting . " " . $name . "!";
    ?>

    `;

    const code7 = `
    Hello, Jane!

    `;

    const code8 = `
    <?php
    print "<h1>Welcome to my Website</h1>";
    ?>

    `;

    const code9 = `
    Welcome to my Website

    `;

    const code10 = `
    <?php
    $imageUrl = "image.jpg";
    print "<img src='$imageUrl' alt='My Image'>";
    ?>    

    `;

    const code11 = `
    <img src='image.jpg' alt='My Image'>   

    `;
    return (
   <body>
      <Helmet>
        <title>PHP Print Statement</title>
       <meta charset="UTF-8" />
       <meta http-equiv="X-UA-compatible" content="IE-edge"/>
       <meta name="Keywords" content="PHP Print Statement, Print Statement Syntax, Outputting Variables, Concatenating Strings, Outputting HTML Attributes, Output HTML Elements, Outputting HTML Attributes,
       Step-by-step PHP programming tutorials, PHP coding exercises for beginners, Advanced PHP coding techniques, Best practices for programming beginners, Search Engine Optimization Guide and tips
       PHP programming tips for real-world applications," />
      <meta name="description" content="Learn how PHP variables are used to store information, streamline code organization, 
      enhance readability, and unlock advanced features in PHP development. " />
       <meta name="viewport" content="width=device-width,initial-scale=1.0" />
      
       </Helmet>
    <br />
        <br />
        <br />
        <br />
        <br />
    <Sidenav />
  
    <div className="content">

<header className="headertutorials" style={newCode}>
<ScrollToTopLink to="/PHP_echo"><ButtonPrevious /></ScrollToTopLink>
<ScrollToTopLink to="/PHP_operators"><ButtonNext /></ScrollToTopLink>
   <h1 style={secondCode}>PHP Print Statement</h1>
</header>

<Navbar />

<main>
<section>
<p>The print statement in PHP serves a similar purpose to the echo statement, allowing developers to output text and variables to web pages.</p>
<p>Like echo, it can output plain text, variables, HTML code, and more, making it essential for building dynamic and interactive web applications. </p>

<br />
<h2>Basic Syntax</h2>
<p>The basic syntax of the 'print' statement is:</p>
<SyntaxHighlighterComponent code={code} language="php" />

<h2>Explanation with Examples:</h2>
<p><b>Outputting Strings:</b> </p>
<SyntaxHighlighterComponent code={code2} language="php" />


<h2>Output</h2>
<SyntaxHighlighterComponent code={code3} language="php" />
<p>In this example, the 'print' statement is used to output the string "Hello, World!".</p>
<br />

<p><b>Outputting Variables:</b> </p>
<SyntaxHighlighterComponent code={code4} language="php" />

<h2>Output</h2>
<SyntaxHighlighterComponent code={code5} language="php" />
<p>Here, the 'print' statement outputs the value stored in the variable $name, which is "John".</p>

<p>< b>Concatenating Strings:</b></p>
<SyntaxHighlighterComponent code={code6} language="php" />

<h2>Output:</h2>
<SyntaxHighlighterComponent code={code7} language="php" />
<p>In this example, we concatenate the strings stored in variables '$greeting', " ", and '$name' using the '.' operator within the 'print' statement.</p>


<p><b>Output HTML Elements:</b></p>
<SyntaxHighlighterComponent code={code8} language="php" />

<h2>Output:</h2>
<SyntaxHighlighterComponent code={code9} language="php" />
<p>Here, the 'print' statement is used to output HTML code. This is useful when generating HTML dynamically within PHP scripts.</p>


<p><b>Outputting HTML Attributes:</b></p>
<SyntaxHighlighterComponent code={code10} language="php" />

<h2>Output:</h2>
<SyntaxHighlighterComponent code={code11} language="php" />
<p>In this example, the 'print' statement outputs an HTML 'img' tag with the src attribute populated dynamically from the '$imageUrl' variable.</p>

</section>

</main>
<div className="head">
<ScrollToTopLink to="/PHP_echo"><ButtonPrevious /></ScrollToTopLink>
<ScrollToTopLink to="/PHP_operators"><ButtonNext /></ScrollToTopLink>
</div>

</div>

<Footertutorials />
   </body>
    )
}